import { Component, OnInit } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { PriorityService } from './../../../../services/administration/priority.service';

@Component({
  selector: 'app-priority',
  templateUrl: './priority.component.html',
  styleUrls: ['./priority.component.scss']
})
export class PriorityComponent implements OnInit {

  gridConfig: GridOptions;
  activeAdd = false;
  dateSelected: any;

  constructor( private priorityService: PriorityService) {
    this.gridConfig = <GridOptions>{};
    this.gridConfig.columnDefs = [
      { headerName: 'Description', field: 'description', colId: 'description', width: 300 }
    ];
  }

  ngOnInit() {
    this.getAllData();
  }

  getAllData() {
    this.priorityService.getAll().subscribe(response => {
      this.gridConfig.api.setRowData(response);
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/pages/administration/reservations/priority/priority.component.ts